var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-lg-3 col-md-5 col-sm-8 mb-3"},[_c('input',{staticClass:"form-control h-42",attrs:{"type":"text","placeholder":"Search Equipment"}})]),_c('div',{staticClass:"col-md-12"},[_vm._v(" put list here ")])])
}]

export { render, staticRenderFns }